<template>
  <section class="invoice-preview-wrapper">
    <!-- Alert: No item found -->
    <b-alert variant="danger" :show="receipt === undefined">
      <h4 class="alert-heading">Error fetching bill data</h4>
      <div class="alert-body">
        No bill found with this bill id. Check
        <b-link class="alert-link" :to="{ name: 'apps-bill-list' }">
          bill List
        </b-link>
        for other bills.
      </div>
    </b-alert>

    <b-row v-if="receipt" class="invoice-preview">
      <!-- Col: Left (Invoice Container) -->
      <b-col cols="12" xl="9" md="8">
        <b-card no-body class="invoice-preview-card size-print-page">
          <!-- Header -->
          <b-card-body class="invoice-padding pb-0">
            <div
              class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0"
            >
              <!-- Header: Left Content -->
              <div>
                <div class="logo-wrapper">
                  <logo />
                  <h3 class="text-primary invoice-logo">ERP NewTech</h3>
                </div>
                 <b-card-text class="mb-25">
                  {{ receipt.createdBy.country }}, {{ receipt.createdBy.postalCode }}
                </b-card-text>
                  <b-card-text class="mb-25">
                  {{ receipt.createdBy.address }}
                </b-card-text>
                <b-card-text class="mb-0">
                      Tel: {{ receipt.createdBy.companyTel }}, Fax: {{ receipt.createdBy.companyFax }}
                </b-card-text>
                     <b-card-text class="mb-0">
                      Email: {{ receipt.createdBy.companyEmail }}
                </b-card-text>
              </div>

              <!-- Header: Right Content -->
              <div class="mt-md-0 mt-2">
                <h4 class="invoice-title">
                  Réçu
                  <span class="invoice-number">#{{ receipt.code }}</span>
                </h4>
                <div class="invoice-date-wrapper">
                  <p class="invoice-date-title">Date de cré:</p>
                  <p class="invoice-date">
                    {{ externalDateFormat(receipt.date) }}
                  </p>
                </div>
                   <div class="invoice-date-wrapper">
                  <p class="invoice-date-title">Date de livraison:</p>
                  <p class="invoice-date">
                    {{ externalDateFormat(receipt.deliveryDate) }}
                  </p>
                </div>
              </div>
            </div>
          </b-card-body>

          <!-- Spacer -->
          <hr class="invoice-spacing" />

          <!-- Invoice Client & Payment Details -->
          <b-card-body v-if="receipt.customer && receipt.customer!=''" class="invoice-padding pt-0">
            <b-row class="invoice-spacing">
              <!-- Col: Invoice To -->
              <b-col cols="12" xl="6" class="p-0">
                <h6 class="mb-2">Facture à:</h6>
                <h6 class="mb-25">
                  {{ receipt.customer.firstName }}
                  {{ receipt.customer.lastName }}
                </h6>
                <!-- <b-card-text class="mb-25">
                      {{ client.company }}
                    </b-card-text> -->
                <b-card-text class="mb-25">
                  {{ receipt.customer.address }},
                  {{ receipt.customer.city }}
                </b-card-text>
                <b-card-text class="mb-25">
                  {{ receipt.customer.email }}
                </b-card-text>
                <b-card-text class="mb-0">
                  {{ receipt.customer.telNumbers.toString() }}
                </b-card-text>
              </b-col>

              <!-- Col: Payment Details -->
              <b-col
                xl="6"
                cols="12"
                class="p-0 mt-xl-0 mt-2 d-flex justify-content-xl-end"
              >
                <div>
                  <h6 class="mb-2">Détails paiement:</h6>
                  <table>

                     <tbody v-if="receipt.createdBy">
                      <tr>
                        <td class="pr-1">Nom du bank :</td>
                        <td>{{receipt.createdBy.bankName}}</td>
                      </tr>
                      <tr>
                        <td class="pr-1">IBAN:</td>
                        <td>{{receipt.createdBy.iban}}</td>
                      </tr>
                      <tr>
                        <td class="pr-1">code SWIFT:</td>
                        <td>{{receipt.createdBy.swiftCode}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-col>
            </b-row>
          </b-card-body>

          <!-- Invoice Description: Table -->
          <b-table-lite
            responsive
            :items="arrayReceipt"
            :fields="[
              { key: 'index', label: '#' },
              { key: 'total', label: 'Prix Totale' },
              { key: 'price', label: 'Prix du reçu' },
              { key: 'newPrice', label: 'Prix restant' },
            ]"
          >
            <template #cell(index)="dataIndex">
              {{ dataIndex.index + 1 }}
            </template>

            <template #cell(newPrice)="dataPrice">
              {{
                Number.parseFloat(dataPrice.item.total)-
                Number.parseFloat(dataPrice.item.price)
              }}
            </template>
          </b-table-lite>

          <!-- Invoice Description: Total -->
          <b-card-body class="invoice-padding pb-0 price-footer-print">

            <b-row>
              <!-- Col: Sales Persion -->
              <b-col
                cols="12"
                md="6"
                class="mt-md-0 mt-3 remove-element-print"
                order="2"
                order-md="1"
              >
                <b-card-text class="mb-0">
                  <span class="font-weight-bold">Vendeur:</span>
                  <span class="ml-75">{{ receipt.salesperson }}</span>
                </b-card-text>
              </b-col>
  <b-col
                  cols="12"
                  md="6"
                  class="mt-md-0 mt-3 add-element-print"
                  order="2"
                  order-md="1"
                >
                  <b-card-text class="mb-0" v-if="printWithSignature">
                    <span class="font-weight-bold">Signature:</span>
                 <span class="mlt-50">   <img :src="receipt.createdBy.signature" alt="signature" class="print-signature"></span>
                  </b-card-text>
              </b-col>
              <!-- Col: Total -->
             
            </b-row>
          </b-card-body>

          <!-- Spacer -->
          <hr class="invoice-spacing" />

        </b-card>
      </b-col>

      <!-- Right Col: Card -->
      <b-col cols="12" md="4" xl="3" class="invoice-actions">
        <b-card>
          <!-- Button: Send Invoice -->
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            v-b-toggle.sidebar-send-email
            variant="primary"
            class="mb-75"
            block
          >
            Envoyé Facture
          </b-button>

          <!-- Button: DOwnload -->
          <!-- <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            class="mb-75"
            block
          >
            Télécharger
          </b-button> -->

          <!-- Button: Print -->
              <!-- Button: Print -->
    <b-button v-if="receipt.createdBy.signature"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            class="mb-75"
            block
            @click="printInvoice(false)"
          >
            Imprimer avec signature
          </b-button>
   <b-button v-if="receipt.createdBy.signature"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            class="mb-75"
            block
            @click="printInvoice(true)"
          >
            Imprimer sans signature
          </b-button>
          <b-button v-if="!receipt.createdBy.signature"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            class="mb-75"
            block
            @click="printInvoice(true)"
          >
            Imprimer signature
          </b-button>


          <!-- Button: Add Payment -->
          <!-- <b-button
            v-b-toggle.sidebar-invoice-add-payment
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="success"
            class="mb-75"
            block
          >
            Add Payment
          </b-button> -->
        </b-card>
      </b-col>
    </b-row>

    <sidebar-send-email
      :data="{
        name: 'Facture',
        email: receipt.customer.email,
        code: receipt.code,
      }"
    />
  </section>
</template>

<script>
// utils
import { DateFormat } from "@/utils/filter.js";
import { GetLinkCurrency } from "@/utils/utils.js";
import store from "@/store";
import router from "@/router";
import axios from "axios";
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BTableLite,
  BCardText,
  BButton,
  BAlert,
  BLink,
  VBToggle,
} from "bootstrap-vue";
import Logo from "@core/layouts/components/Logo.vue";
import Ripple from "vue-ripple-directive";
import SidebarSendEmail from "./../../composants/sidebar/SidebarSendEmail.vue";

export default {
  directives: {
    Ripple,
    "b-toggle": VBToggle,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BTableLite,
    BCardText,
    BButton,
    BAlert,
    BLink,
    Logo,
    SidebarSendEmail,
  },
  data() {
    return {
      receipt:{},
      arrayReceipt:[],
      printWithSignature:false,
      user: {
        adress: "lorem ipsum is my location",
        ville: "tunis",
        city: "Tunisia",
        postalCode: "1000",
        PhoneNumber: "99777555",
        signature:"https://upload.wikimedia.org/wikipedia/commons/thumb/5/56/Autograph_of_Benjamin_Franklin.svg/1200px-Autograph_of_Benjamin_Franklin.svg.png"
      },
    };
  },
  async created() {
    await this.getSubInvoiceData()
  },
  methods: {
    // external Filter
    externalDateFormat(date) {
      return DateFormat(date);
    },
    // external utils
    externalUserCurrency() {
      return GetLinkCurrency();
    },
    // Other function
    // print
    printInvoice(arg) {
      this.printWithSignature=arg
      window.print();
    },
    UpdateQuote() {
      var routerLink =
        "/shop/bill/edit-bill?id=" + this.$router.history.current.query.id;
      this.$router.replace(routerLink);
    },
    getSubInvoiceData(){
         axios
        .get(
          "https://management-projects.herokuapp.com/api/sales-receipts?bill=" +
            this.$router.history.current.query.bill
        )
        .then((response) => {
          console.log(response.data);
          const receipt = response.data.filter(
            (r) => (r._id == this.$router.history.current.query.id)
          )[0];
          axios
            .get(
              "https://management-projects.herokuapp.com/api/users?id=" +
                receipt.salesBill.customer
            )
            .then((response) => {
              const customer = response.data;
              this.receipt = {
                customer,
                ...receipt,
              };
              console.log( this.receipt);
              this.arrayReceipt[0]= this.receipt 
            })
            .catch((error) => {
              this.errorMessage = error.message;
            });
        })
        .catch((error) => {
          this.errorMessage = error.message;
        });
    },
    // filters
  },
};
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
</style>

<style lang="scss">
@media print {
  // Global Styles
  body {
    background-color: transparent !important;
  }
  nav.header-navbar {
    display: none;
  }
  .main-menu {
    display: none;
  }
  .header-navbar-shadow {
    display: none !important;
  }
  .content.app-content {
    margin-left: 0;
    padding-top: 2rem !important;
  }
  footer.footer {
    display: none;
  }
  .card {
    background-color: transparent;
    box-shadow: none;
  }
  .customizer-toggle {
    display: none !important;
  }

  // Invoice Specific Styles
  .invoice-preview-wrapper {
    .row.invoice-preview {
      .col-md-8 {
        max-width: 100%;
        flex-grow: 1;
      }

      .invoice-preview-card {
        .card-body:nth-of-type(2) {
          .row {
            > .col-12 {
              max-width: 50% !important;
            }

            .col-12:nth-child(2) {
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              margin-top: 0 !important;
            }
          }
        }
      }
    }

    // Action Right Col
    .invoice-actions {
      display: none;
    }
  }
}
.product-description {
  font-size: 12px !important;
}
</style>
